"use strict";

import Page from "./RevenueOfEvent.jsx";

export const auth = true;
export const title = "i18n:eventRevenue.pageTitle";
export const Component = Page;
